// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__sO1T3","header":"styles_header__5VI6M","searchBox":"styles_searchBox__Tw7pO","candidateTable":"styles_candidateTable__E+wJe"};